import React from "react";

const NextArrow = (props) =>
{
return(
    <div className="slick-nav next-arrow" onClick={props.onClick}>
        <i></i> <svg><use xlinkHref="#circle" /></svg>
    </div> 
);

}

export default NextArrow